import { Alert, Group, Text } from '@mantine/core';
import { IconEye, IconX } from '@tabler/icons-react';
import { BasicButton } from 'src/design/atoms/BasicButton';

export interface IAssumedUserBannerProps {
  assumedUserName?: string;
  onStopAssuming: () => void;
}

/** @registry Fixed bottom banner shown while an admin is impersonating another user ("Acting as ..."), with a button to stop; renders nothing when assumedUserName is undefined. */
export const AssumedUserBanner: React.FC<IAssumedUserBannerProps> = ({
  assumedUserName,
  onStopAssuming,
}) => {
  if (!assumedUserName) return null;

  return (
    <Alert
      data-testid="assumed-user-banner"
      icon={<IconEye size={18} />}
      color="blue"
      variant="filled"
      radius={0}
      styles={{
        root: {
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1400,
        },
      }}
    >
      <Group justify="center" gap="sm">
        <Text data-testid="assumed-user-name" size="sm" c="white">
          Acting as {assumedUserName}
        </Text>
        <BasicButton
          data-testid="stop-assuming-button"
          size="compact-xs"
          color="white"
          variant="filled"
          c="blue"
          leftSection={<IconX size={14} />}
          onClick={onStopAssuming}
        >
          Stop Acting As User
        </BasicButton>
      </Group>
    </Alert>
  );
};
